import React, { useState } from "react";
import Select from "react-select";
import classnames from "classnames";
import "./multipleselect.scss";
import CreatableSelect from "react-select/creatable";
import { components } from "react-select";
import { isEmpty } from "lodash";

function MultipleSelect({
  label,
  options,
  value = [],
  onChange,
  onCreateOption,
  hideNoOptions = false,
  formatCreateLabel,
  componentsOverload,
  className,
  isCreatable = false,
}) {
  const [inputValue, setInputValue] = useState();

  if (value === undefined || value === null) {
    value = [];
  }

  var SelectComponent = isCreatable ? CreatableSelect : Select;

  const onInputChange = (textInput, { action }) => {
    if (action === "input-change") {
      // Normalize textinput
      var textNormalized = textInput.trim();

      // Parse already added commas
      if (textNormalized && textNormalized.includes(",")) {
        var newValues = textNormalized.split(",");
        newValues = newValues.map((s) => s.trim());
        newValues = newValues.filter((s) => !isEmpty(s));

        var endsWithComma = textNormalized.endsWith(",");

        if (endsWithComma) {
          setInputValue("");
        } else {
          setInputValue(newValues.pop());
        }

        if (isCreatable) {
          onCreateOption(newValues);
        }
      } else {
        setInputValue(textInput);
      }
    }
  };

  const classes = classnames(
    "grigora-multi-select-input text-sm mb-2 ",
    className,
  );
  return (
    <div className={classes}>
      {label && (
        <span className="grigora-select-input__label  text-grigora-base">
          {label}
        </span>
      )}
      <SelectComponent
        classNamePrefix={"multiselect-ui-basic"}
        placeholder=""
        value={value}
        options={options}
        onChange={onChange}
        inputValue={inputValue}
        isMulti
        onCreateOption={(newVal) => {
          onCreateOption(newVal);
          setInputValue("");
        }}
        theme={(theme) => ({
          ...theme,
          borderRadius: 0,
          colors: {
            ...theme.colors,
            primary25: "var(--color-ui-light-blue-background)",
            primary: "white",
          },
        })}
        // menuIsOpen={true}
        formatCreateLabel={formatCreateLabel}
        noOptionsMessage={hideNoOptions ? () => null : undefined}
        components={{
          ...components,
          ...componentsOverload,
        }}
        onInputChange={onInputChange}
      />
    </div>
  );
}

export default MultipleSelect;
